import { reactive } from 'vue'

/**
 * 分享引导浮层全局状态
 * 仅做轻提示（点击右上角 ··· 分享），不强制、不诱导，点击遮罩即可关闭。
 */
const state = reactive({
  visible: false
})

export function useShareGuide() {
  const openShareGuide = () => {
    state.visible = true
  }
  const closeShareGuide = () => {
    state.visible = false
  }
  return { state, openShareGuide, closeShareGuide }
}
